module.exports = __webpack_public_path__ + "static/media/opl3.png.d19e485d.jpg";